<template>
  <div class="main-setting-menu">
    <HeaderMenu
      :arrow="arrow"
      :title="$t('licenseCode.name')"
      :routeBackName="routeBackName"
    />
    <div class="item">
      <div class="bold mrg-b-3">{{ $t("licenseCode.enterCode") }}</div>
      <div>
        <input
          @keyup.enter="updateLic"
          class="w-100 input-border"
          v-model="code"
        />
      </div>
      <div class="flex flex-bet">
        <baseButton class="mrg-t-6" @click="updateLic()">{{
          $t("licenseCode.update")
        }}</baseButton>
      </div>
    </div>
  </div>
</template>

<script>
// import { mapGetters, mapActions } from "vuex";
import menuService from "@/services/menu";
import { updateLicense } from "@/services/offline/license.js";
import { doHardReload } from "@/services/bookData.js";

export default {
  data() {
    return {
      routeBackName: "help",
      code: "",
    };
  },
  props: {
    arrow: { default: true },
  },

  methods: {
    updateLic() {
      if (!this.code) return;
      let message = "",
        type = "";

      updateLicense(this.code.replace(/[^0-9]/g, "")).then((res) => {
        if (res) {
          menuService.closeMenu();
          type = "success";
          message =
            this.$t("about.succedUpdateLicens") + this.$t("about.refreshNow");

          //refresh list if needed
          doHardReload();
        } else {
          message = this.$t("about.errorUpdate");
          type = "error";
        }
        const notification = {
          type,
          message,
          timeout: 3000,
        };
        this.$notify(notification);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  padding: 20px;
}
</style>
